import { render, staticRenderFns } from "./FomoNotifications.vue?vue&type=template&id=334124ca&scoped=true&"
import script from "./FomoNotifications.vue?vue&type=script&lang=js&"
export * from "./FomoNotifications.vue?vue&type=script&lang=js&"
import style0 from "./FomoNotifications.vue?vue&type=style&index=0&id=334124ca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "334124ca",
  null
  
)

export default component.exports